import FileSaver from 'file-saver';
import { createAuthorizationHeaderValue } from 'lib-shared-auth';
import { config } from 'lib-shared-backend-config';

function isPrivate(url) {
  return url.includes(`${config.url.files}/private`);
}

export default function fetchFile(url, download?: any) {
  if (!url) {
    console.log('URL WAS NULL!');
    return '';
  }
  if (!isPrivate(url)) {
    return url;
  }
  return () => {
    return new Promise((resolve, reject) => {
      createAuthorizationHeaderValue().then((headerValue) => {
        const headers = new Headers();
        headers.append('Authorization', headerValue);

        const request = {
          method: 'GET',
          headers,
          mode: 'cors',
          cache: 'no-cache',
        };

        fetch(url, request as any)
          .then((response) => response.blob())
          .then((blob) => {
            if (download) {
              FileSaver.saveAs(blob, decodeURIComponent(url.split('/').pop()));
            }
            const blobURL = window.URL.createObjectURL(blob);
            resolve(blobURL);
          })
          .catch((e) => {
            reject(e);
          });
      });
    });
  };
}
